export function loadStateFromStorage<T>(storageKey: string): T | null {
    if (typeof localStorage === 'undefined') return null;
    try {
        const stored = localStorage.getItem(storageKey);
        return stored ? JSON.parse(stored) : null;
    } catch (e) {
        console.error(`Failed to load state from localStorage (${storageKey})`, e);
        return null;
    }
}

export function saveStateToStorage<T>(storageKey: string, state: T): void {
    if (typeof localStorage === 'undefined') return;
    try {
        localStorage.setItem(storageKey, JSON.stringify(state));
    } catch (e) {
        console.error(`Failed to save state to localStorage (${storageKey})`, e);
    }
}
